import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Widget from "../../../../../shared/components/features/widget/Widget";
import NavigateLink from "../../../../../shared/components/features/navigateLink/navigateLink";
import Icon from "../../../../../shared/components/ui/icons/Icon";
import iconsList from "../../../../../shared/components/ui/icons/iconsList";
import pathRouts from "../../../../../shared/enums/pathRoute";
import classes from "./TeachingAssistantWidget.module.css";

const TeachingAssistantWidget = ({ bot }) => {
    const location = useLocation();
    const { texts } = useSelector(state => state.translate);

    return (
        <Widget color="#EBEBEB" title={texts.teachingAssistantsTitle} icon={iconsList.bot} contentScrollable={false} className={classes.TeachingAssistant}>
            <div className={classes.Content}>
                <div className={classes.BotImgWrap}>
                    <img src={bot.imageUrl} alt={texts[bot.name]} className={classes.BotImg} />
                    {bot.icon ?
                        <span className={classes.BotTypeBadge}>
                            <img src={bot.icon} alt="" className={classes.BotTypeBadgeIcon} />
                        </span>
                        : null}
                </div>
                <div className={classes.TextBlock}>
                    <p className={classes.Name}>{texts[bot.name]}</p>
                    <p className={classes.Description}>{texts[bot.descriptionKey]}</p>
                </div>
                <NavigateLink link={`/${pathRouts.BOT}/${bot.key}`} showLoadingPage={false} state={{ from: location.pathname }}>
                    <div className={classes.AskButton}>
                        <span className={classes.AskButtonText}>{texts.askMeSomething}</span>
                        <Icon name={iconsList.arrows} size="14px" color="#000" className={classes.AskButtonIcon} />
                    </div>
                </NavigateLink>
            </div>
        </Widget>
    );
};

export default TeachingAssistantWidget;